import React, { useState, useEffect } from 'react';

// Icons
const TrendingUpIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
    <polyline points="17 6 23 6 23 12"></polyline>
  </svg>
);

const TrendingDownIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline>
    <polyline points="17 18 23 18 23 12"></polyline>
  </svg>
);

const BarChartIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="20" x2="12" y2="10"></line>
    <line x1="18" y1="20" x2="18" y2="4"></line>
    <line x1="6" y1="20" x2="6" y2="16"></line>
  </svg>
);

const LineChartIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 3v18h18"></path>
    <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
  </svg>
);

const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

const UserIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const AwardIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="7"></circle>
    <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
  </svg>
);

const TargetIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <circle cx="12" cy="12" r="6"></circle>
    <circle cx="12" cy="12" r="2"></circle>
  </svg>
);

const ActivityIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
  </svg>
);

const InfoIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
);

const Performance: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState<'week' | 'month' | 'quarter' | 'year'>('month');
  const [userFilter, setUserFilter] = useState<'all' | 'me' | 'team'>('all');

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const metrics = [
    {
      label: 'Total de Vendas',
      value: 'R$ 125.430',
      change: '+15.2%',
      trend: 'up',
      icon: <TrendingUpIcon />,
      color: 'var(--color-success-500)',
      bgColor: 'rgba(34, 197, 94, 0.1)'
    },
    {
      label: 'Oportunidades',
      value: '82',
      subtext: '12 novas este período',
      icon: <TargetIcon />,
      color: 'var(--color-info-500)',
      bgColor: 'rgba(59, 130, 246, 0.1)'
    },
    {
      label: 'Taxa de Conversão',
      value: '24.3%',
      change: '-1.8%',
      trend: 'down',
      icon: <TrendingDownIcon />,
      color: 'var(--color-error-500)',
      bgColor: 'rgba(239, 68, 68, 0.1)'
    },
    {
      label: 'Tarefas',
      value: '156',
      change: '+23.5%',
      trend: 'up',
      icon: <ActivityIcon />,
      color: '#a855f7',
      bgColor: 'rgba(168, 85, 247, 0.1)'
    }
  ];

  const performers = [
    { name: 'João Silva', avatar: 'JS', sales: 'R$ 45.230', opportunities: 18, conversion: '28%', activities: 34, trend: 'up' },
    { name: 'Maria Santos', avatar: 'MS', sales: 'R$ 38.450', opportunities: 15, conversion: '26%', activities: 29, trend: 'up' },
    { name: 'Pedro Costa', avatar: 'PC', sales: 'R$ 32.100', opportunities: 12, conversion: '24%', activities: 25, trend: 'stable' },
    { name: 'Ana Oliveira', avatar: 'AO', sales: 'R$ 28.650', opportunities: 11, conversion: '23%', activities: 22, trend: 'down' },
    { name: 'Carlos Lima', avatar: 'CL', sales: 'R$ 25.980', opportunities: 10, conversion: '22%', activities: 20, trend: 'up' },
  ];

  const getRankColor = (index: number) => {
    if (index === 0) return '#eab308';
    if (index === 1) return '#9ca3af';
    if (index === 2) return '#f97316';
    return 'var(--color-primary-500)';
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: 'var(--space-16)'
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          border: '3px solid var(--color-primary-200)',
          borderTopColor: 'var(--color-primary-600)',
          animation: 'spin 1s linear infinite'
        }} />
      </div>
    );
  }

  return (
    <div style={{ padding: 'var(--space-6)', maxWidth: '1600px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{ marginBottom: 'var(--space-6)' }}>
        <h1 style={{
          fontSize: 'var(--text-3xl)',
          fontWeight: 'var(--font-weight-bold)',
          color: 'var(--text-primary)',
          marginBottom: 'var(--space-2)'
        }}>
          Performance
        </h1>
        <p style={{ fontSize: 'var(--text-base)', color: 'var(--text-secondary)' }}>
          Acompanhe o desempenho da equipe
        </p>
      </div>

      {/* Filters */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'var(--space-4)',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 'var(--space-4)',
        background: 'var(--glass-bg-strong)',
        backdropFilter: 'var(--glass-blur)',
        borderRadius: 'var(--radius-xl)',
        border: '1px solid var(--glass-border)',
        marginBottom: 'var(--space-6)'
      }}>
        {/* Period Selector */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
          <CalendarIcon />
          <span style={{ fontWeight: 'var(--font-weight-medium)', color: 'var(--text-primary)' }}>Período:</span>
          <div style={{ display: 'flex', gap: 'var(--space-2)' }}>
            {(['week', 'month', 'quarter', 'year'] as const).map((p) => (
              <button
                key={p}
                onClick={() => setPeriod(p)}
                style={{
                  padding: 'var(--space-2) var(--space-4)',
                  borderRadius: 'var(--radius-lg)',
                  border: 'none',
                  background: period === p ? 'var(--gradient-primary)' : 'var(--bg-secondary)',
                  color: period === p ? 'white' : 'var(--text-secondary)',
                  fontSize: 'var(--text-sm)',
                  fontWeight: 'var(--font-weight-medium)',
                  cursor: 'pointer',
                  transition: 'all var(--transition-fast)'
                }}
              >
                {p === 'week' && 'Semana'}
                {p === 'month' && 'Mês'}
                {p === 'quarter' && 'Trimestre'}
                {p === 'year' && 'Ano'}
              </button>
            ))}
          </div>
        </div>

        {/* User Filter */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
          <UserIcon />
          <span style={{ fontWeight: 'var(--font-weight-medium)', color: 'var(--text-primary)' }}>Visualizar:</span>
          <div style={{ display: 'flex', gap: 'var(--space-2)' }}>
            {(['all', 'me', 'team'] as const).map((filter) => (
              <button
                key={filter}
                onClick={() => setUserFilter(filter)}
                style={{
                  padding: 'var(--space-2) var(--space-4)',
                  borderRadius: 'var(--radius-lg)',
                  border: 'none',
                  background: userFilter === filter ? 'linear-gradient(135deg, #a855f7, #6366f1)' : 'var(--bg-secondary)',
                  color: userFilter === filter ? 'white' : 'var(--text-secondary)',
                  fontSize: 'var(--text-sm)',
                  fontWeight: 'var(--font-weight-medium)',
                  cursor: 'pointer',
                  transition: 'all var(--transition-fast)'
                }}
              >
                {filter === 'all' && 'Todos'}
                {filter === 'me' && 'Meu'}
                {filter === 'team' && 'Equipe'}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Summary Stats */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: 'var(--space-4)',
        marginBottom: 'var(--space-6)'
      }}>
        {metrics.map((metric, index) => (
          <div
            key={index}
            style={{
              padding: 'var(--space-5)',
              background: 'var(--glass-bg-strong)',
              backdropFilter: 'var(--glass-blur)',
              borderRadius: 'var(--radius-xl)',
              border: '1px solid var(--glass-border)'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--space-3)' }}>
              <div>
                <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-secondary)', marginBottom: 'var(--space-1)' }}>
                  {metric.label}
                </p>
                <p style={{ fontSize: 'var(--text-2xl)', fontWeight: 'var(--font-weight-bold)', color: 'var(--text-primary)' }}>
                  {metric.value}
                </p>
              </div>
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: 'var(--radius-lg)',
                background: metric.bgColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: metric.color
              }}>
                {metric.icon}
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-1)' }}>
              {metric.change ? (
                <>
                  <span style={{ color: metric.color, fontWeight: 'var(--font-weight-medium)', fontSize: 'var(--text-sm)' }}>
                    {metric.change}
                  </span>
                  <span style={{ color: 'var(--text-tertiary)', fontSize: 'var(--text-sm)' }}>
                    vs período anterior
                  </span>
                </>
              ) : (
                <span style={{ color: metric.color, fontSize: 'var(--text-sm)' }}>
                  {metric.subtext}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Performance Chart */}
      <div style={{
        padding: 'var(--space-5)',
        background: 'var(--glass-bg-strong)',
        backdropFilter: 'var(--glass-blur)',
        borderRadius: 'var(--radius-xl)',
        border: '1px solid var(--glass-border)',
        marginBottom: 'var(--space-6)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--space-4)' }}>
          <div>
            <h3 style={{ fontSize: 'var(--text-lg)', fontWeight: 'var(--font-weight-semibold)', color: 'var(--text-primary)', marginBottom: 'var(--space-1)' }}>
              Histórico de Performance
            </h3>
            <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-secondary)' }}>
              Evolução ao longo do tempo
            </p>
          </div>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: 'var(--radius-lg)',
            background: 'rgba(59, 130, 246, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--color-info-500)'
          }}>
            <LineChartIcon />
          </div>
        </div>
        <div style={{
          height: '200px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--bg-tertiary)',
          borderRadius: 'var(--radius-lg)'
        }}>
          <div style={{ textAlign: 'center', color: 'var(--text-tertiary)' }}>
            <LineChartIcon />
            <p style={{ fontSize: 'var(--text-sm)', marginTop: 'var(--space-2)' }}>
              Gráfico será implementado na próxima etapa
            </p>
          </div>
        </div>
      </div>

      {/* Top Performers */}
      <div style={{
        padding: 'var(--space-5)',
        background: 'var(--glass-bg-strong)',
        backdropFilter: 'var(--glass-blur)',
        borderRadius: 'var(--radius-xl)',
        border: '1px solid var(--glass-border)',
        marginBottom: 'var(--space-6)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--space-4)' }}>
          <div>
            <h3 style={{ fontSize: 'var(--text-lg)', fontWeight: 'var(--font-weight-semibold)', color: 'var(--text-primary)', marginBottom: 'var(--space-1)' }}>
              Top Performers
            </h3>
            <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-secondary)' }}>
              Melhores resultados do período
            </p>
          </div>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: 'var(--radius-lg)',
            background: 'rgba(234, 179, 8, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#eab308'
          }}>
            <AwardIcon />
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
          {performers.map((performer, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: 'var(--space-4)',
                background: 'var(--bg-secondary)',
                borderRadius: 'var(--radius-lg)',
                transition: 'all var(--transition-fast)'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-4)' }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  background: getRankColor(index),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: 'var(--font-weight-semibold)',
                  fontSize: 'var(--text-sm)'
                }}>
                  {performer.avatar}
                </div>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
                    <h4 style={{ fontWeight: 'var(--font-weight-medium)', color: 'var(--text-primary)' }}>
                      {performer.name}
                    </h4>
                    {index < 3 && (
                      <span style={{ color: getRankColor(index) }}>
                        <AwardIcon />
                      </span>
                    )}
                  </div>
                  <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-secondary)' }}>
                    {performer.opportunities} oportunidades • {performer.activities} atividades
                  </p>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-6)' }}>
                <div style={{ textAlign: 'right' }}>
                  <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-tertiary)' }}>Vendas</p>
                  <p style={{ fontWeight: 'var(--font-weight-semibold)', color: 'var(--text-primary)' }}>
                    {performer.sales}
                  </p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-tertiary)' }}>Conversão</p>
                  <p style={{ fontWeight: 'var(--font-weight-semibold)', color: 'var(--text-primary)' }}>
                    {performer.conversion}
                  </p>
                </div>
                <div style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: 'var(--radius-lg)',
                  background: 'var(--bg-primary)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: performer.trend === 'up'
                    ? 'var(--color-success-500)'
                    : performer.trend === 'down'
                    ? 'var(--color-error-500)'
                    : 'var(--text-tertiary)'
                }}>
                  {performer.trend === 'up' ? <TrendingUpIcon /> : performer.trend === 'down' ? <TrendingDownIcon /> : <BarChartIcon />}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Info Banner */}
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 'var(--space-3)',
        padding: 'var(--space-4)',
        background: 'rgba(168, 85, 247, 0.1)',
        borderRadius: 'var(--radius-xl)',
        border: '1px solid rgba(168, 85, 247, 0.3)'
      }}>
        <div style={{ color: '#a855f7', marginTop: '2px' }}>
          <InfoIcon />
        </div>
        <div>
          <h4 style={{ fontWeight: 'var(--font-weight-semibold)', color: 'var(--text-primary)', marginBottom: 'var(--space-1)' }}>
            Funcionalidades Em Desenvolvimento
          </h4>
          <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-secondary)', lineHeight: '1.5' }}>
            Esta é a página base de Performance. Na próxima etapa serão implementados:
            Gráficos detalhados por usuário, Análise comparativa, Metas e objetivos,
            Rankings dinâmicos, Histórico completo e Exportação de dados de performance.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Performance;
